mutation DeleteProducts($ids: [ID!]!) {
  deleteProducts(ids: $ids)
}
